import React, { useState, useEffect } from 'react';

const SearchAndFilter = ({ placeholder, onSearch, onFilter, filtersConfig, filterValues: externalFilterValues }) => {
  const [searchTerm, setSearchTerm] = useState(''); // Состояние для поиска
  const [localFilterValues, setLocalFilterValues] = useState({}); // Локальное состояние для значений фильтров
  const [showDropdown, setShowDropdown] = useState(false); // Состояние для отображения выпадающего списка

  // Синхронизация локальных фильтров с внешними при смене таба
  useEffect(() => {
    setLocalFilterValues(externalFilterValues);
  }, [externalFilterValues]);

  // Обработка изменения поля поиска
  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    onSearch(value); // Вызываем переданную функцию поиска
  };

  // Обработка изменения значения фильтра
  const handleFilterChange = (field, value) => {
    setLocalFilterValues((prevValues) => ({
      ...prevValues,
      [field]: value, // Обновляем значение конкретного поля фильтра
    }));
  };

  // Обработка применения фильтра
  const handleFilter = () => {
    onFilter(localFilterValues); // Передаем текущие значения фильтров
    setShowDropdown(false); // Закрываем выпадающий список после применения фильтров
  };

  // Сброс фильтров
  const resetFilter = () => {
    const clearedState = {};
    filtersConfig.forEach((filter) => {
      clearedState[filter.field] = ''; // Очищаем все значения фильтров
    });
    setLocalFilterValues(clearedState); // Обновляем локальное состояние фильтров
  
    // ВАЖНО: Передаем пустой объект, чтобы сигнализировать о сбросе всех фильтров
    onFilter({});
  };
  

  // Обработка закрытия выпадающего списка
  const closeDropdown = () => {
    setShowDropdown(false); // Закрываем выпадающий список
  };

  return (
    <div className="search">
      {/* Поле для поиска */}
      <input
        type="search"
        className="table__search"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleSearch}
      />

      {/* Кнопка для отображения выпадающего списка фильтров */}
      <div className="filter">
        <button className="btn filter dropdown" onClick={() => setShowDropdown(!showDropdown)}>
          <svg className="filter__icon" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <use xlinkHref="#filter"></use>
          </svg>
          Filter
        </button>

        {/* Выпадающий список фильтров */}
        {showDropdown && (
          <div className="dropdown__content show">
            {/* Кнопка закрытия выпадающего списка */}
            <button className="popup__close-button" onClick={closeDropdown}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref="#closeBtn"></use>
              </svg>
            </button>
            <h3 className="filter__heading">Filters:</h3>
            <div className="row">
              {/* Динамическое отображение фильтров на основе filtersConfig */}
              {Array.isArray(filtersConfig) && filtersConfig.map((filter) => (
                <div key={filter.field} className="filter__field">
                  <label>{filter.label}</label>
                  <input
                    type={filter.type || 'text'} // Тип фильтра (по умолчанию текст)
                    className="filter__input"
                    value={localFilterValues[filter.field] || ''} // Значение фильтра из локального состояния
                    onChange={(e) => handleFilterChange(filter.field, e.target.value)} // Обработка изменения фильтра
                  />
                </div>
              ))}
            </div>

            {/* Кнопки применения и сброса фильтров */}
            <hr className="decor__line" />
            <div className="row space__between">
              <input
                type="button"
                className="btn btn__green"
                value="Filter"
                onClick={handleFilter} // Применение фильтров
              />
              <input
                type="button"
                className="btn btn__grey"
                value="Reset"
                onClick={resetFilter} // Сброс фильтров
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilter;
